module.exports = function() {
  return new Worker(__webpack_public_path__ + "29201e971361afe86431.worker.js");
};